module.exports = __webpack_public_path__ + "static/media/22222.e392aaa1.jpg";